module.exports = __webpack_public_path__ + "img/red_antenna.c93b783f.svg";